/**
 * Nomes canônicos dos eventos do funil. Fonte única — nunca escrever a string
 * solta num componente, senão o funil do PostHog quebra silenciosamente.
 */
export const ANALYTICS_EVENTS = {
  /** A pessoa concluiu o cadastro. Topo do funil de ativação. */
  CADASTRO_CONCLUIDO: "cadastro_concluido",
  /** Vinculou pelo menos uma rede social — primeiro sinal de intenção real. */
  REDE_SOCIAL_VINCULADA: "rede_social_vinculada",
  /** Criou a primeira tarefa/conteúdo. */
  PRIMEIRA_TAREFA_CRIADA: "primeira_tarefa_criada",
  /** Abriu a tela de planos. */
  PLANOS_VISUALIZADOS: "planos_visualizados",
  /** Clicou em assinar e o checkout foi criado. */
  CHECKOUT_INICIADO: "checkout_iniciado",
} as const;

export type AnalyticsEvent =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
